import { Pipe, PipeTransform } from '@angular/core';
import { CardOrderingStatus } from '@app/shared/enums/CardOrderingStatus.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'cardOrderingStatus',
    standalone: false
})
export class CardOrderingStatusPipe implements PipeTransform {
  public cardOrderingStatus = CardOrderingStatus;
  public cardOrderingStatusList: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
   }

  transform(value: any): string {
    if (value === null || value === undefined) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const states = Array.isArray(value) ? value : [value];

    if (states.length === 0) {
      return this.translate.instant('ENUMS.NO_STATE');
    }

    const translatedStates = states
      .map(state => {
        const key = Object.keys(CardOrderingStatus).find(
          k => CardOrderingStatus[k as keyof typeof CardOrderingStatus] === state
        );
        return key ? this.translate.instant(`ENUMS.${key}`) : null;
      })
      .filter(Boolean);

    return translatedStates.length > 0
      ? translatedStates.join(', ')
      : this.translate.instant('ENUMS.NO_STATE');
  }

  getList() {
    this.cardOrderingStatusList = [];

    for (const [propertyKey, propertyValue] of Object.entries(CardOrderingStatus)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
      this.cardOrderingStatusList.push({ id: propertyValue, name: nameAndText, text: nameAndText });
    }

    return this.cardOrderingStatusList;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(CardOrderingStatus)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return { id: propertyValue, name: nameAndText, text: nameAndText };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(CardOrderingStatus)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
